// Libs
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
// Components, Layouts, Pages
// Others
import { formatCurrency } from '~/utils/helper/common';
import { IFormPO } from '~/utils/interface/po';
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
// Styles, images, icons
import styles from './TotalFieldPOProduct.module.scss';

type Props = { index: number };

const cx = classNames.bind(styles);

const TotalFieldPOProduct = (props: Props) => {
  //#region Destructuring Props
  const { index } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { control, setValue } = useFormContext<IFormPO>();

  const quantity = useWatch({ control, name: `products.${index}.quantity` });
  const cost = useWatch({ control, name: `products.${index}.cost` });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [totalCost, setTotalCost] = useState<number>(DEFAULT_NUMBER_ZERO);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    const totalCost = Number(cost) * Number(quantity);
    setValue(`products.${index}.totalCost`, totalCost, {
      shouldDirty: true,
    });
    setTotalCost(totalCost);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity, cost]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Typography id='totalFieldPOProduct' className={cx('textTotal')}>
      {formatCurrency(totalCost)}
    </Typography>
  );
};

export default TotalFieldPOProduct;
